import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { policies } from '@services/api'

export class policiesStore extends StoreExt {
    @observable list = []
    @observable parentsList = []
    @observable childrenList = []
    @observable filteredList = []
    @observable filterText = ''
    @observable filters = {}
    @observable editPolicy = {}
    @observable similarPolicies = []
    @observable pagination = {
        page: 1,
        perPage: 8,
        total: 0
    }

    @action
    getList = async params => {
        const { policies: list } = (await policies.getList(params)).data
        runInAction(() => {
            this.list = list
            this.filterPoliciesList()
        })
    }

    @action
    getSimilarPolicies = async params => {
        const similarPolicies = (await policies.getSimilarPolicies(params)).data
        runInAction(() => {
            this.similarPolicies = similarPolicies
        })
    }

    @action
    getPaginationList = async () => {
        const { data: list, page, total, perPage } = (
            await policies.getList({ ...this.filters, ...this.pagination })
        ).data
        runInAction(() => {
            this.list = list
            this.pagination = { page, perPage, total }
        })
    }

    @action
    setFilters = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }

    @action
    setPagination = async params => {
        runInAction(() => {
            if (params.page) this.pagination.page = params.page
            if (params.perPage) this.pagination.perPage = params.perPage
            this.getPaginationList()
        })
    }

    @action
    setFilterText = text => {
        runInAction(() => {
            this.filterText = text
            this.filterPoliciesList()
        })
    }

    @action
    filterPoliciesList = () => {
        runInAction(() => {
            if (this.list.length > 0) {
                this.filteredList = this.list.filter(
                    item => item.name.includes(this.filterText) || item.id === this.filterText
                )
            }
        })
    }

    @action
    getParentPolicies = async (company_id, policy_id) => {
        const { childrenList, parentsList } = (await policies.getParentList({ company_id, policy_id })).data
        runInAction(() => {
            if (childrenList.length > 0) {
                this.childrenList = childrenList
            } else {
                this.parentsList = parentsList
            }
            this.filterList(this.filterText)
        })
    }

    @action
    filterList = filterText => {
        this.filterText = filterText
        runInAction(() => {
            if (this.childrenList.length > 0) {
                this.filteredList = this.childrenList.filter(
                    item => item.name.includes(filterText) || item.id === filterText
                )
            } else {
                this.filteredList = this.parentsList.filter(
                    item => item.name.includes(filterText) || parseFloat(filterText) === item.id
                )
            }
        })
    }

    @action
    resetEdit = () => {
        this.editPolicy = {}
    }

    @action
    resetLists = () => {
        this.parentsList = []
        this.childrenList = []
        this.filteredList = []
        this.filterText = ''
        this.filters = {}
    }
}

export default remotedev(new policiesStore())
